import log from "loglevel";
// Course Content
// Interactions
// Performance
// Pages

// Include Following Pages
// Landing Page
// Login Page
// Terms
// Privacy Policy
// Contact us
import React, { useEffect, useRef, useCallback, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Routes, Route, Navigate, useParams, useNavigate, useLocation } from "react-router-dom";
import httpService from "services/httpService";
import displayGlobalMessage from "Utils/DisplayGlobalMessage";
import {
  Tabs,
  Tab,
  Container,
  Button,
  Spinner,
} from "react-bootstrap";
import SideBar from "Components/Instructor/SideBar";
import SideBarV2 from "Screens/Instructor/CourseUIV2/SideBar";
import { useFeatureFlags } from "hooks/useFeatureFlags";
import { usePlatformSettings } from "hooks/usePlatformSettings";
import Activity from "Navigation/Course/Content/Labs/Instructor/CodeEditor/ActivityContainer.jsx"
// import MobileSideBar from "../../Components/Instructor/MobileSideBar";
// import { FaFolder, FaRegPlayCircle, FaFileAlt } from "react-icons/fa";


// import AppBar from "Components/Student/AppBar";
// import AppBar1 from "Components/Student/AppBar1";
// import { bindActionCreators } from "redux";
// import { modeRoutes } from "Store/UserInfo/Actions";

// import ProfileButton from "Screens_old/Layout/Common/Components/ProfileButton";
// import LoginButton from "Screens_old/Layout/Common/Components/LoginButton";
// import Profile from "./Profile";

//jk
// import { DisplayPlaylist } from "Screens1/Student/Course/Content/Multimedia/CoursePlaylist";
// import CoursePlaylist from "Screens1/Student/Course/Content/Multimedia/CoursePlaylist";
// import Labs from "./Content/Labs";
// import Labs from "Screens1/Student/Course/Content/Labs";
// import ListActivity from "../../Screens1/Student/Course/Content/Labs/ListActivity";
// import StudentView from "Screens1/Instructor/Course/Content/OtherLabs/Containers/StudentView";

// import CourseEnroll from "Screens1/Student/CourseEnroll";
import * as actions from "Store/Course/Student/Actions";
import * as constants from "Constants";
// import LabContainer from "./Content/Labs/Student/LabContainer/LabContainer";
// import ActivityContainer from "./Content/Labs/Student/ActivityContainer/ActivityContainer.jsx";
// import NavBar from "Screens_old/Layout/Common/Components/NavBar";
import { loadCoursesListRequest } from "Screens_old/PublicCourses/Common/Actions/Actions";
import { loadCoursesListRequest as instructor_loadCoursesListRequest } from "Store/MyDashboard/Instructor/Actions";
import { loadCoursesListRequest as student_loadCoursesListRequest } from "Store/MyDashboard/Student/Actions";
import { setUserCourseRole, setCourseApprovalStatus } from "Store/Course/MultipleRoles/Actions";
import Footer from "Screens_old/Layout/Common/Components/Footer";
import AnnouncementsNavigation from "./Interactions/Announcements";
import AboutCourseStudent from "Screens1/Student/Course/Content/About";
import { AddPage, PageInfoInstructor } from "Screens1/Instructor/Course/Pages";
import PageInfoStudent from "Screens1/Student/Course/Pages";
import Notes from "Components/Student/Notes";

// routes
const ContentNavigation = React.lazy(() => import('Navigation/Course/Content'));
const InteractionsNavigation = React.lazy(() => import('Navigation/Course/Interactions'));
const PerformanceNavigation = React.lazy(() => import('Navigation/Course/Performance'));
const ManagementNavigation = React.lazy(() => import('Navigation/Course/Management'));
const PagesNavigation = React.lazy(() => import('Navigation/Course/Pages'));

const STATUS_ENUM = {
  "APPROVED": "APPROVED",
  "UNENROLLED": "UNENROLLED",
  "PENDING_APPROVAL": "PENDING_APPROVAL",
  "DATA_LOADING": "DATA_LOADING",
  "NO_DATA": "NO_DATA"
};


const CourseNavigation = (props) => {
  log.log("course navigation");
  const { routeProps } = props;
  const params = useParams();
  const { courseId } = params;
  const isTemplateCode = params["*"] && params["*"].includes("templatecode");
  const [courseTitle, setCourseTitle] = useState("")
  const [loading, setLoading] = useState(true);
  const [thisCourse, setThisCourse] = useState();
  // log.log("+++++++", { thisCourse, setThisCourse });
  const [status, setStatus] = useState(false);
  const [isOwner, setIsOwner] = useState(false);
  // const [studentLoading, setStudentLoading] = useState(true);
  const { token, mode } = useSelector(state => state.userInfo);
  // Get persisted approval status from Redux - survives component remounts
  const courseApprovalStatus = useSelector(state => state.courseApprovalStatus?.[courseId]);
  let courses = useSelector(state => state.publicCoursesMap);
  let instructorCourses = useSelector(state => state.instructorCoursesMap);
  let studentCourses = useSelector(state => state.studentCoursesMap);
  const [course, setCourse] = useState(null);
  // const [item, setItem] = useState(null);
  // const [activeTab, setActiveTab] = useState('multimedia_book');
  const [pages, setPages] = useState([]);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const location = useLocation();
  const { enableInstructorV2 } = useFeatureFlags();
  const { settings: platformSettings } = usePlatformSettings();
  const visibility = platformSettings?.section_visibility || {};

  const [key, setKey] = useState(null);
  const tabsContainerRef = useRef(null);


  /**
   * Stores user role
   * @param {string} role eg JTA/STA/INSTRUCTOR
   */
  const storeRole = (role) => {
    dispatch(setUserCourseRole(role));
  };

  // Helper to get the first visible section path
  const getFirstVisiblePath = () => {
    if (visibility.multimedia_book !== false) return `/courseware/course/${courseId}/content/multimedia`;
    if (visibility.labs !== false) return `/courseware/course/${courseId}/content/labs`;
    if (visibility.schedule !== false) return `/courseware/course/${courseId}/interactions/schedule`;
    if (visibility.announcements !== false) return `/courseware/course/${courseId}/interactions/announcements`;
    if (visibility.interaction !== false) return `/courseware/course/${courseId}/interactions/discussion-forum`;
    if (visibility.performance !== false) return `/courseware/course/${courseId}/performance`;
    if (visibility.about_course !== false) return `/courseware/course/${courseId}/content/about`;
    if (visibility.extra_pages !== false) return `/courseware/course/${courseId}/pages`;
    return `/courseware/course/${courseId}/content/multimedia`; // Fallback
  };

  // Helper to get the first visible tab key
  const getFirstVisibleTab = () => {
    if (visibility.multimedia_book !== false) return "multimedia_book";
    if (visibility.labs !== false) return "Labs";
    if (visibility.schedule !== false) return "Schedule";
    if (visibility.announcements !== false) return "Announcements";
    if (visibility.interaction !== false) return "Interaction";
    if (visibility.performance !== false) return "Performance";
    if (visibility.about_course !== false) return "AboutCourse";
    if (visibility.extra_pages !== false) return "ExtraPages";
    return "multimedia_book"; // Fallback
  };

  // Redirect away from hidden sections when accessing via direct URL
  useEffect(() => {
    // Wait for platform settings to load
    if (!platformSettings) return;

    const path = location.pathname;
    let shouldRedirect = false;

    // Check if current path is for a hidden section
    if (path.includes('/content/multimedia') && visibility.multimedia_book === false) {
      shouldRedirect = true;
    } else if (path.includes('/content/labs') && visibility.labs === false) {
      shouldRedirect = true;
    } else if (path.includes('/interactions/schedule') && visibility.schedule === false) {
      shouldRedirect = true;
    } else if (path.includes('/interactions/announcements') && visibility.announcements === false) {
      shouldRedirect = true;
    } else if ((path.includes('/interactions/discussion-forum') || path.includes('/interactions/email-notices')) && visibility.interaction === false) {
      shouldRedirect = true;
    } else if (path.includes('/performance') && visibility.performance === false) {
      shouldRedirect = true;
    } else if (path.includes('/content/about') && visibility.about_course === false) {
      shouldRedirect = true;
    } else if (path.includes('/pages') && visibility.extra_pages === false) {
      shouldRedirect = true;
    }

    if (shouldRedirect) {
      navigate(getFirstVisiblePath(), { replace: true });
    }
  }, [location.pathname, platformSettings, visibility, courseId, navigate]);

  useEffect(() => {
    // Only run in student mode - instructor mode uses sidebar for navigation
    if (mode === "I") return;

    let defKey = "";

    if (location.pathname.includes("multimedia") && visibility.multimedia_book !== false) {
      defKey = "multimedia_book";
    } else if (location.pathname.includes("announcements") && visibility.announcements !== false) {
      defKey = "Announcements";
    } else if (location.pathname.includes("schedule") && visibility.schedule !== false) {
      defKey = "Schedule";
    } else if (location.pathname.includes("interactions") && visibility.interaction !== false) {
      defKey = "Interaction";
    } else if (location.pathname.includes("labs") && visibility.labs !== false) {
      defKey = "Labs";
    } else if (location.pathname.includes("performance") && visibility.performance !== false) {
      defKey = "Performance";
    } else if (location.pathname.includes("about") && visibility.about_course !== false) {
      defKey = "AboutCourse";
    } else if (location.pathname.includes("pages") && visibility.extra_pages !== false) {
      defKey = "ExtraPages";
    }
    else if (location.pathname.includes("notes") && visibility.notes !== false) {
      defKey = "Notes";
    }
    else {
      defKey = getFirstVisibleTab();
    }
    setKey(defKey);
    log.log("Course Navigation: ", defKey, location);
  }, [location, mode, visibility]);

  useEffect(() => {
    if (!key || !tabsContainerRef.current) return;

    // Wait for DOM to finish updating
    setTimeout(() => {
      try {
        // Get the nav-tabs container (which is a child of our ref)
        const tabsContainer = tabsContainerRef.current.querySelector('.nav-tabs');

        if (!tabsContainer) {
          log.error("Could not find .nav-tabs element");
          return;
        }

        // Find the active tab element by class
        const activeTab = tabsContainer.querySelector('.nav-link.active');

        if (activeTab) {
          // Get the position of the active tab
          const tabPosition = activeTab.offsetLeft;
          const tabWidth = activeTab.offsetWidth;

          // Get the container width
          const containerWidth = tabsContainer.offsetWidth;

          // Calculate position to center the tab
          const scrollPosition = tabPosition - (containerWidth / 2) + (tabWidth / 2);

          // Apply the scroll to the .nav-tabs element
          tabsContainer.scrollLeft = scrollPosition;
        }
      } catch (error) {
        log.error("Error scrolling to tab:", error);
      }
    }, 200); // Increased timeout to ensure DOM is updated
  }, [key]);

  useEffect(() => {
    if (location.pathname.includes("//")) {
      let loc = location.pathname.replace("//", "/");
      navigate(loc);
    }
  }, [location.key]);


  useEffect(() => {
    log.log({ thisCourse, status });
    setCourseTitle({ thisCourse, status }?.thisCourse?.title)
  }, [thisCourse, status])

  // Note: Approval status is now stored in Redux (courseApprovalStatus) to survive remounts

  // const isAuthenticated = token !== null;
  // const [isAuthenticated, setIsAuthenticated] = useState(false);
  // const [mode, setMode] = useState(null);
  // const [courses, setCourses] = useState([]);
  // const [token, setToken] = useState(null);
  // const [username, setusername] = useState(null);

  // const handleConceptChange = (item) => setItem(item);

  // const handleModeChange = (mode, token) => {
  //   log.log("mode is new ", mode);
  //   let error = "Can't switch mode";
  //   if (mode !== mode) {
  //     modeRoutes(mode, token);
  //   }
  // }

  // Only fetch course lists if not already loaded, and only for the current mode
  // Do NOT include courses/instructorCourses/studentCourses as dependencies
  // to avoid infinite re-fetch loops when list contents change.
  useEffect(() => {
    if (!courses || courses.length === 0) {
      dispatch(loadCoursesListRequest());
    }

    if (mode === 'I' && (!instructorCourses || instructorCourses.length === 0)) {
      dispatch(instructor_loadCoursesListRequest());
    }

    if (mode === 'S' && (!studentCourses || studentCourses.length === 0)) {
      dispatch(student_loadCoursesListRequest());
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, mode]);

  // const getProfileButton = () => {
  //   if (isAuthenticated) {
  //     return <ProfileButton title={email || username} />;
  //   } else {
  //     return <LoginButton />;
  //   }
  // }

  // const userInfo = useSelector(state => state.userInfo);
  // const isAuthenticated = userInfo.token !== null,
  //   mode: state.userInfo.mode,
  //   courses: state.publicCoursesMap,
  //   token: state.userInfo.token,
  //   userName: state.userInfo.username,

  // let { routeProps, courses } = this.props;
  // let { path, params } = routeProps.match;
  // let { courseId } = params;
  // log.log("PROPS:", this.props);
  // log.log("Path:", path);
  // log.log("This is the mode:", mode);
  // log.log(courses);

  useEffect(() => {
    let tempCourse;
    if (courses?.length > 0) {
      tempCourse = courses.find((item) => item.id === Number(courseId));
      // log.log({ courseSetCourse: tempCourse, courses, courseId });
      setCourse(tempCourse?.title);
      setThisCourse(tempCourse);
    }
    if (!tempCourse) {
      if (instructorCourses && instructorCourses.length > 0) {
        tempCourse = instructorCourses.find((item) => item.id === Number(courseId));
        // log.log({ courseSetCourse: tempCourse, instructorCourses, courseId });
        setCourse(tempCourse?.title);
        setThisCourse(tempCourse);
      }
    }
    if (!tempCourse) {
      if (studentCourses && studentCourses.length > 0) {
        tempCourse = studentCourses.find((item) => item.id === Number(courseId));
        setCourse(tempCourse?.title);
        setThisCourse(tempCourse);
      }
    }
    setLoading(false);
  }, [courses, courseId, instructorCourses, studentCourses]);

  // Check if the course exists and is accessible (not trashed/deleted).
  // If the course API returns 404, redirect to the courses list.
  useEffect(() => {
    const checkCourseAccess = async () => {
      try {
        await httpService.get(constants.base_url + "/courseware/api/course/" + courseId + "/", { skipErrorToast: true });
      } catch (err) {
        if (err?.response?.status === 404) {
          displayGlobalMessage("This course is no longer available.", "error");
          navigate('/courseware/courseslist', { replace: true });
          return;
        }
        // 403 is expected for unenrolled students — registration_data handles enrollment UI
        if (err?.response?.status === 403) {
          return;
        }
        // Genuine errors (500, network) — show toast
        displayGlobalMessage("Something went wrong", "error");
      }
    };
    checkCourseAccess();
  }, [courseId, navigate]);

  useEffect(() => {
    const isApproved = status === "APPROVED" || status === "OWNER"
      || courseApprovalStatus === "APPROVED" || courseApprovalStatus === "OWNER";

    const fetchPages = async () => {
      try {
        let url = constants.base_url + "/courseware/api/course/" + courseId + "/pages/";
        let res = await httpService.get(url, { skipErrorToast: true });
        log.log(res.data);
        setPages(res.data);
      } catch (err) {
        log.error(err);
        // Show toast only for genuine errors (not 403 which is handled by enrollment flow)
        if (err?.response?.status !== 403) {
          displayGlobalMessage("Something went wrong", "error");
        }
      }
    };

    if (isApproved) {
      fetchPages();
    }
    fetchCourseUserMapping();
  }, [courseId, status, courseApprovalStatus]);

  useEffect(() => {
    const doStuff = async () => {
      if (token) {
        try {
          setLoading(true);
          // const response = await httpService.get(`/courseware/api/course/${props.course.id}`);
          log.log("params");
          log.log(params);
          const response = await actions.registration_data(courseId);
          // log.log(response);
          if (response) {
            log.log(response.status);
            // window.location.href = `/courseware/course/${props.course.id}/`;
            // history.push(`/courseware/course/${course.id}/`);
            setStatus(response.status);
            setIsOwner(response.owner);
            // Store in Redux to persist across remounts - prevents tab flickering
            dispatch(setCourseApprovalStatus(courseId, response.status));

            // If user was removed from course, refresh the course list to remove stale entry
            if (response.status === "UNENROLLED") {
              if (mode === 'I') {
                dispatch(instructor_loadCoursesListRequest());
              } else if (mode === 'S') {
                dispatch(student_loadCoursesListRequest());
              }
            }
          } else {
            setStatus(false);
            setIsOwner(false);
          }
        }
        catch (e) {
          log.log(e);
          setStatus(false);
          setIsOwner(false);
        } finally {
          setLoading(false);
        }
      } else {
        setLoading(false);
      }
    };
    doStuff();
  }, [token, courseId]);

  // Callback to check course access before sidebar navigation
  // Returns true if navigation should proceed, false if user was removed or demoted
  const handleBeforeNavigate = useCallback(async () => {
    if (!token) return true;

    try {
      // Use get_enrollment_status to check the user's current role
      const url = `/courseware/api/course/${courseId}/get_enrollment_status/`;
      const result = await httpService.get(url);
      const role = result?.data?.role;

      // If in instructor mode, check if user still has instructor/TA role
      if (mode === 'I') {
        const instructorRoles = ['INSTRUCTOR', 'STA', 'JTA'];
        if (!role || !instructorRoles.includes(role)) {
          displayGlobalMessage("You no longer have instructor access to this course.", "error");
          dispatch(instructor_loadCoursesListRequest());
          navigate('/courseware/courseslist');
          return false;
        }
      }

      return true;
    } catch (e) {
      log.log("Error checking course access:", e);
      // If API returns 403/404, user likely doesn't have access
      if (e?.response?.status === 403 || e?.response?.status === 404) {
        displayGlobalMessage("You no longer have access to this course.", "error");
        if (mode === 'I') {
          dispatch(instructor_loadCoursesListRequest());
        } else {
          dispatch(student_loadCoursesListRequest());
        }
        navigate('/courseware/courseslist');
        return false;
      }
      return true; // Allow navigation on other errors, backend will block if needed
    }
  }, [token, courseId, mode, dispatch, navigate]);

  const handleTabSelect = (selectedKey) => {
    setKey(selectedKey);
    switch (selectedKey) {
      case 'multimedia_book':
        navigate(`/courseware/course/${courseId}/content/multimedia/coursecontent`);
        break;
      case 'Labs':
        navigate(`/courseware/course/${courseId}/content/labs`);
        break;
      case 'Interaction':
        navigate(`/courseware/course/${courseId}/interactions/discussion-forum`);
        break;
      case 'Performance':
        navigate(`/courseware/course/${courseId}/performance`);
        break;
      case 'Announcements':
        navigate(`/courseware/course/${courseId}/interactions/announcements`);
        break;
      case 'AboutCourse':
        navigate(`/courseware/course/${courseId}/content/about`);
        break;
      case 'Schedule':
        navigate(`/courseware/course/${courseId}/interactions/schedule`);
        break;
      case 'ExtraPages':
        navigate(`/courseware/course/${courseId}/pages/`);
        break;
      case 'Notes':
        navigate(`/courseware/course/${courseId}/notes`);
        break;
      default:
        break;
    }
  };


  /**
   * API Call to get user role associated with a course
   */
  const fetchCourseUserMapping = async () => {

    let url = "/courseware/api/course/" + courseId + "/get_enrollment_status/";

    try {
      const result = await httpService.instance({
        method: "get",
        url: url,
        data: {},
        headers: {
          Authorization: `Token ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });
      log.debug('result course user mapping get: ', result.data);
      storeRole(result.data.role);
      // setSelectedStudents([]);
      // displayGlobalMessage("Student Enrolled in Course", "success");
    } catch (error) {
      log.error("Error enrolling student:", error);
      // displayGlobalMessage("Error while getting user Course", "error");
    }
  };


  switch (mode) {
    case "I":
      return (
        <>
          {!isTemplateCode ? (
            <>
              {/* <NavBar /> */}
              <Container className="container-fluid my-3 py-3 px-0" style={{ minHeight: "90vh" }}>
                {/* <Navbar1 navbarClass="navbar-dark fixed-top" /> */}
                {
                  loading ? <div className="w-100 h-100 d-flex justify-content-center p-5">
                    <Spinner animation="border" size="sm" />
                  </div> : (isOwner && status === "APPROVED") ?
                    <div
                      id="courseBody"
                      className="d-flex flex-row px-4"
                      style={{ minWidth: "70%" }}
                    >
                      <div className="col-xl-2 col-md-4 col-lg-4 sideListContainer p-0">
                        {enableInstructorV2 ? (
                          <SideBarV2 pages={pages} courseId={courseId} visibility={visibility} onBeforeNavigate={handleBeforeNavigate} />
                        ) : (
                          <SideBar routeProps={routeProps} pages={pages} courseId={courseId} visibility={visibility} />
                        )}
                      </div>

                      <div
                        id="course-content-div"
                        className="col-xl-10 col-md-8 col-lg-8"
                      >

                        <div className="courseHeader" style={{ marginTop: 0 }}>
                          <div className="d-flex flex-row px-3" style={{ minWidth: "70%" }}>
                            <h1 className="courseHeaderTitle">{course}</h1>
                          </div>
                        </div>

                        <Routes>
                          <Route
                            path={`/content/*`}
                            element={<React.Suspense fallback='...Loading content nav'><ContentNavigation routeProps={routeProps} /></React.Suspense>}
                            render={(routeProps) => {
                              return <React.Suspense fallback='...Loading'><ContentNavigation routeProps={routeProps} /></React.Suspense>;
                            }}
                          />
                          <Route
                            path={`/interactions/*`}
                            element={<React.Suspense fallback='...Loading'><InteractionsNavigation routeProps={routeProps} /></React.Suspense>}
                            render={(routeProps) => {
                              return <React.Suspense fallback='...Loading'><InteractionsNavigation routeProps={routeProps} /></React.Suspense>;
                            }}
                          />
                          <Route
                            path={`/performance/*`}
                            element={<React.Suspense fallback='...Loading'><PerformanceNavigation routeProps={routeProps} /></React.Suspense>}
                            render={(routeProps) => {
                              return <React.Suspense fallback='...Loading'><PerformanceNavigation routeProps={routeProps} /></React.Suspense>;
                            }}
                          />
                          <Route
                            path={`/management/*`}
                            element={<React.Suspense fallback='...Loading'><ManagementNavigation routeProps={routeProps} /></React.Suspense>}
                            render={(routeProps) => {
                              return <React.Suspense fallback='...Loading'><ManagementNavigation routeProps={routeProps} /></React.Suspense>;
                            }}
                          />
                          {/* <Route
                      path={`/pages/*`}
                      element={<React.Suspense fallback='...Loading'><PagesNavigation routeProps={routeProps} pages={pages} setPages={setPages} /></React.Suspense>}
                      render={(routeProps) => {
                        return <React.Suspense fallback='...Loading'><PagesNavigation routeProps={routeProps} pages={pages} setPages={setPages} /></React.Suspense>;
                      }}
                    /> */}
                          <Route path="/pages/" element={<PagesNavigation pages={pages} setPages={setPages} />}>
                            <Route path="addpage" element={<AddPage courseID={courseId} pages={pages} setPages={setPages} />} />
                            <Route path=":pageid" element={<PageInfoInstructor courseID={courseId} pages={pages} setPages={setPages} />} />
                            <Route path={`notes/*`} element={<Notes routeProps={routeProps} />} />
                          </Route>
                          <Route path="" element={<Navigate to={`content`} replace />} />
                        </Routes>
                      </div>
                    </div>
                    :
                    (status === "UNENROLLED") ?
                      <Container style={{ minHeight: "90vh" }}>
                        <div className={`${status === "UNENROLLED" ? "" : "d-none"}`}>
                          <p>
                            Please switch to Student mode to enroll the course.
                          </p>
                        </div>
                      </Container>
                      : (!isOwner && status === "APPROVED") ?
                        <Container>You are not an instructor of this course</Container> : <Container> Request Failed </Container>
                }
                {/* {status === "APPROVED" && } */}
              </Container>
              <Footer />
            </>
          ) :
            <>

              <h2 style={{ marginLeft: "10rem" }}>
                {courseTitle}
              </h2>
              <div style={{ textAlign: 'center' }}>
                <h5 style={{ fontSize: '24px', color: 'black' }}>
                  Template Code
                </h5>
              </div>
              <Container
                style={{
                  display: "flex",
                  justifyContent: "center",
                  border: '0.5px solid grey',
                  alignItems: "center",
                  marginBottom: '20px',
                  padding: '0'
                }}
              >
                <Activity courseId={courseId} />
              </Container>
            </>
          }
        </>
      );

    default:
      // try {
      //   const response = await httpService.get(`/courseware/api/course/${props.course.id}`);
      //   if (response.status === 200) {
      //     // window.location.href = `/courseware/course/${props.course.id}/`;
      //     // history.push(`/courseware/course/${course.id}/`);
      //     setStudentLoading(false);
      //   } else {
      //     alert("You are not permitted to go inside this course!");
      //   }
      // }
      // catch (e) {
      //   alert("You are not permitted to go inside this course!");
      // }
      // if (studentLoading) {
      //   return <div>Loading</div>
      // }
      // Render routes with Suspense boundary for lazy-loaded components
      const renderRoutes = () => (
        <React.Suspense fallback={
          <div className="w-100 d-flex justify-content-center align-items-center" style={{ minHeight: "60vh" }}>
            <Spinner animation="border" />
          </div>
        }>
          <Routes>
            <Route path={`/content/*`} element={<ContentNavigation routeProps={routeProps} thisCourse={thisCourse} setThisCourse={setThisCourse} />} />
            <Route path={`/interactions/*`} element={<InteractionsNavigation routeProps={routeProps} />} />
            <Route path={`/performance/*`} element={<PerformanceNavigation routeProps={routeProps} />} />
            <Route path={`/management`} element={<ManagementNavigation routeProps={routeProps} />} />
            <Route path={`/interactions/announcements`} element={<AnnouncementsNavigation routeProps={routeProps} pages={pages} setPages={setPages} />} />
            <Route path={`/content/about/`} element={<AboutCourseStudent courseId={courseId} />} />
            <Route path="/pages/:pageid?" element={<PageInfoStudent courseID={courseId} pages={pages} setPages={setPages} />} />
            <Route path="" element={<Navigate to="content/multimedia" />} />
          </Routes>
        </React.Suspense>
      );

      return (
        <div className="px-0" style={{ width: "100%" }}>
          {/* <NavBar /> */}
          {status !== "NOT_PUBLISHED" && (
            <Container className="container-lg my-1 mt-2 px-1 px-md-0">
              <h3 className="responsive-h3 my-3 my-md-0">{thisCourse?.title}</h3>
            </Container>
          )}
          <Container className="container-lg border my-1 mt-2 py-2 px-0" mx-0 style={{ minHeight: "90vh", width: "100% !important", maxWidth: "none !important" }}>
            {/* Show tabs if approved (from Redux or local state), hide only if explicitly unenrolled */}
            {/* courseApprovalStatus from Redux survives component remounts, preventing tab flicker */}
            {(courseApprovalStatus === "APPROVED" || courseApprovalStatus === "OWNER" ||
              status === "APPROVED" || status === "OWNER" ||
              (status === false && courseApprovalStatus !== "UNENROLLED" && courseApprovalStatus !== "PENDING_APPROVAL" && courseApprovalStatus !== "NOT_PUBLISHED")) && (
              <div className="scrollable-tabs-container" ref={tabsContainerRef}>
                <Tabs
                  id="controlled-tab-example"
                  activeKey={key}
                  onSelect={handleTabSelect}
                  className="student-nav-course-content responsive-h4 px-4"
                >
                  {visibility.multimedia_book !== false && <Tab eventKey="multimedia_book" title="Multimedia Book" />}
                  {visibility.labs !== false && <Tab eventKey="Labs" title="Labs" />}
                  {visibility.schedule !== false && <Tab eventKey="Schedule" title="Schedule" />}
                  {visibility.announcements !== false && <Tab eventKey="Announcements" title="Announcements" />}
                  {visibility.interaction !== false && <Tab eventKey="Interaction" title="Interaction" />}
                  {visibility.performance !== false && <Tab eventKey="Performance" title="Performance" />}
                  {visibility.about_course !== false && <Tab eventKey="AboutCourse" title="About Course" />}
                  {visibility.extra_pages !== false && <Tab eventKey="ExtraPages" title="Extra Pages" />}
                  {visibility.notes !== false && <Tab eventKey="Notes" title="Notes" />}
                </Tabs>
              </div>
            )}
            {/* Content area with stable Suspense boundary */}
            {loading || status === false ? (
              <div className="w-100 d-flex justify-content-center align-items-center" style={{ minHeight: "80vh" }}>
                <Spinner animation="border" />
              </div>
            ) : (courseApprovalStatus === "APPROVED" || courseApprovalStatus === "OWNER" || status === "APPROVED" || status === "OWNER") ?
              <div>
                {renderRoutes()}
              </div>
              : (status === "NOT_PUBLISHED") ?
                <Container className="d-flex flex-column justify-content-center align-items-center" style={{ minHeight: "80vh" }}>
                  <p className="text-muted h5">
                    This course is not available.
                  </p>
                </Container>
              : (status !== "APPROVED") ?
                <Container className="d-flex flex-column" style={{ minHeight: "80vh" }}>
                  <div className="courseHeader mb-6 mb-md-0">
                    <div className="w-100 d-block">
                      <p className="courseHeaderTitle text-break h4 d-block w-100">{course}</p>
                    </div>
                  </div>
                  <div className="w-100 d-bloc mt-5 mt-md-0">
                    <div className={`${status === "UNENROLLED" ? "" : "d-none"}`}>
                      <p className="text-break">
                        You are not a registered student of this course. Please Enroll in this course.
                      </p>
                      <Button
                        variant="success"
                        onClick={async () => {
                          try {
                            const response = await actions.register_to_course(courseId);
                            if (response) {
                              log.log(response);
                              switch (response.status) {
                                case "PENDING_APPROVAL":
                                  setStatus(response.status);
                                  break;
                                case "APPROVED":
                                  window.location.reload();
                                  break;
                                default:
                                  break;
                              }
                            }
                          } catch (err) {
                            log.error("Error occurred while enrolling", err);
                          }
                        }}
                      >
                        Enroll
                      </Button>
                    </div>
                    <div className={`${status === "PENDING_APPROVAL" ? "" : "d-none"}`}>
                      <p>
                        Your approval is Pending.
                      </p>
                      <Button
                        variant="danger"
                        onClick={async () => {
                          const response = await actions.unregister_course_request(courseId);
                          if (response) {
                            log.log(response);
                            setStatus("UNENROLLED");
                          }
                        }}
                      >
                        Cancel Enrollment
                      </Button>
                    </div>
                  </div>
                </Container>
                : null}
          </Container >
          <Footer />
        </div>
      );
  }
};

// export default connect(mapStateToProps, mapDispatchToProps)(CourseNavigation);

export default CourseNavigation;

